import { render, staticRenderFns } from "./NanoLoanRates.vue?vue&type=template&id=1ec4edeb&scoped=true"
import script from "./NanoLoanRates.vue?vue&type=script&lang=js"
export * from "./NanoLoanRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4edeb",
  null
  
)

export default component.exports